<template>
  <div v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || usuarioProyectoId == getUsuarioID">
    <v-snackbar v-model="mostrarSnackbar" :timeout="3000" :color="colorSnack">
      <div class="d-flex justify-space-around">
        <span class="ma-2 font-weight-bold"> {{ mensajeSnack }} </span>
        <v-btn text dark @click="mostrarSnackbar = !mostrarSnackbar"> Cerrar </v-btn>
      </div>
    </v-snackbar>

    <v-container fluid class="white elevation-3 margen d-flex justify-space-between">
      <v-row class="d-flex  justify-space-between">
        <v-col cols="12" sm="12" md="3" class="my-auto d-flex">
          <v-btn small text class="mt-3 mx-3 grey lighten-2" to="/proyecto">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <h1>Proyecto</h1>
        </v-col>
        <v-col cols="12" sm="12" md="3" class="my-auto">
          <span class="mt-2 text-h4 ml-auto">
            {{ mostrarFolio }}
          </span>

        </v-col>
      </v-row>
    </v-container>

    <v-container fluid class="mt-3 mr-4 pa-2 white margen">
      <div class="d-flex justify-space-between">
        <div class="d-flex">
          <span class="text-h5 mx-3">Información.</span>
          <v-btn v-if="infoProyecto && infoProyecto.PESTATUS !== 'T'" class="mx-3 red darken-1" dark small text @click="editar = !editar">
            Editar.
          </v-btn>
        </div>

        <div>
          
        </div>
      </div>

      <!-- <v-card :disabled="editar" class="ma-3 pa-3"> -->
      <v-card :disabled="editar" class="ma-3 pa-3">
        <v-row>
        <v-col cols="12" sm="12" md="6">
          <v-autocomplete
            filled
            dense
            v-model="clienteSeleccionado[0]"
            label="Cliente"
            :items="clientes"
            item-text="NOMBRE"
            item-value="NOMBRE"
            :loading="cargandoCliente"
            return-object
            class="mx-2"
          />
        </v-col>
        
        <v-col cols="12" sm="12" md="6">
          <v-autocomplete :items="tiposProyecto" label="Tipo" v-model="tipo" item-text="TIPO" item-value="VALOR" dense  filled />
        </v-col>

        <v-col cols="12" sm="12" md="12" class="py-0">
        <!-- SECCION FECHA -->
        <v-menu
          v-model="modalFecha"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="fechaSeleccionada"
              label="Fecha a entregar"
              prepend-icon="mdi-calendar"
              filled
              light
              readonly
              dense
              v-bind="attrs"
              v-on="on"
            >
            </v-text-field>
          </template>
          <v-date-picker
            v-model="fechaSeleccionada"
            @input="modalFecha = false"
            :min="minFecha[0]"
          >
          </v-date-picker>
        </v-menu>
        <!-- FIN SECCION FECHA -->
        </v-col>

        <v-col cols="12" sm="12" md="6" class="py-0">
          <v-text-field
            class="mx-2"
            label="Factura"
            filled
            dense
            v-model="factura"
          />
        </v-col>

        <v-col cols="12" sm="12" md="3" class="py-0">
          <v-text-field label="Costo" v-model="costo" prefix="$" min="0" dense type="number" filled />
        </v-col>

        <v-col cols="12" sm="12" md="3" class="py-0">
          <v-text-field label="Venta" v-model="venta" prefix="$" min="0" dense type="number" filled />
        </v-col>

        
        </v-row>


        <div class="d-flex justify-center mb-2">
          <v-btn class="mx-3 colorP darken-1" 
            dark small text :loading="cargandoModificar" @click="modificarProyecto">
              Guardar.
          </v-btn>
        </div>

        <v-divider></v-divider>

        <!-- SECCION PRODUCTOS -->
        <div class="my-2">
          <div class="text-h6 mx-3 d-flex justify-center ma-1">
            <span class="mouse noselect" v-ripple @click="mostrarProductos=!mostrarProductos">
            Productos 
            <v-icon dense light>
              {{ iconoFlecha }}
              </v-icon>
            </span>
          </div>

          <transition name="fade">
            <v-expansion-panels accordion v-if="mostrarProductos"
             class=" elevation-0 justify-start"
             focusable 
             multiple>
             <v-card-title style="width:100%;" class="grey lighten-1">
                <div> Productos 
                  <span class="subtitle-1 d-flex" style="display:block; word-break:break-word!important;"> 
                    <!-- <ModalExcel  @EXCEL="archivoExcel"/> -->
                    <v-btn class="success darken-1 mx-2" small text @click="mostrarModalProductos = true">
                      Agregar Producto/s
                    </v-btn>
                    <v-dialog v-model="mostrarModalProductos" max-width="">
                        <ModalAgregarProducto 
                        :infoProyecto="infoProyecto"
                        @cerrarModal="mostrarModalProductos=false"/>
                    </v-dialog>
                   <u>{{ mostrarExcel }}</u>
                  </span>
                </div>
                
             </v-card-title>

              <div>
                
              </div>
              <v-expansion-panel v-for="producto in productos" :key="producto.PRODUCTO_ID">
                
                <ModalEliminarProducto
                :producto="producto"
                @eliminarProducto="eliminarProducto(producto.PRODUCTO_ID)"/>
                  
                <v-expansion-panel-header expand-icon="mdi-menu-down" class="d-flex">
                  <v-row>
                    <v-col cols="6" xs="6" md="3" class="font-weight-bold">{{producto.NOMBRE}}                   </v-col>
                    <v-col cols="6" xs="6" md="3" class="font-weight-bold">{{producto.CLAVE_MSP}}                </v-col>
                    <v-col cols="6" xs="6" md="3" class="font-weight-bold">Cantidad: {{producto.CANTIDAD}}       </v-col>
                    <v-col cols="6" xs="6" md="3" class="font-weight-bold">Costo: {{producto.COSTO | currency }} </v-col>
                    <v-col cols="6" xs="6" md="12" class="font-weight-bold" v-if="producto.ARTICULOS && producto.ARTICULOS.length > 0" style="text-align:right;">Articulos   </v-col>
                  </v-row>
                </v-expansion-panel-header>
                
                <v-expansion-panel-content 
                v-for="articulo in producto.ARTICULOS" :key="articulo.ARTICULO_ID" 
                class="mouse borde" 
                v-ripple
                >
                  <div class="d-flex justify-space-between">
                    <div style="width:(100/2)%;"> 
                      <div> {{ articulo.NOMBRE }}</div>
                      <div>
                        Cantidad: 
                        {{ parseInt('' + (articulo.CANTIDAD * 100)) / 100 }} 
                      </div>

                    </div>
                    <div style="width:(100/2)%;" class="my-auto"> 
                      <ModalEliminarArticulo
                      :articulo="articulo"
                      @eliminarArticulo="eliminarArticulo(producto.PRODUCTO_ID, articulo.ARTICULO_ID)"/>
                    </div>
                  </div>
                  <div class="d-flex">
                  </div>
                  </v-expansion-panel-content>
              </v-expansion-panel>

            </v-expansion-panels>
          </transition>

        </div>
        <!-- FIN SECCION PRODUCTOS -->

        </v-card>
        
        <v-card class="ma-3 pa-3">
        <!-- <v-divider></v-divider> -->

        <!-- SECCION ARCHIVOS -->
        
        <div class="my-3">
          <div class="d-flex">
            <div class="text-h6 mx-3">
              Archivos
            </div>
            <div class="text-h6">
              <ModalAgregarArchivos
              :infoProyecto="infoProyecto"
              @getInformacionProyecto="getInformacionProyecto"
              @snackbar="snackbar"
              />
            </div>

          </div>

          <v-row v-if="archivos.length > 0 " >
            <!-- <div class="d-flex justify-space-around"> -->
            <div v-for="archivo in archivos" :key="archivo.ARCHIVO_ID">
              <!-- IMAGENES INGRESADAS -->
              <v-col v-if="archivo.NOMBREARCH.toLowerCase().match(/(\.jpeg|\.jpg|\.png)$/i)"
              cols="6" xs="12" sm="12" md="6" lg="3"
              class="ma-3"
              style="max-width: 120px;" >
                <v-card >
                  <v-card-title style="height: 100px!important; width:100px">
                    <v-img 
                      class="overflow-visible allB"
                      :src="'//' + archivo.RUTAARCH"
                    >
                      <ModalEliminarArchivos 
                        :archivo='archivo'
                        @getInformacionProyecto="getInformacionProyecto" 
                        style="float:right; margin-top:-22%; margin-right:-30%;"
                      />
                    </v-img>
                  </v-card-title>
                  <v-card-text :class="claseCSSArchivo(archivo)" class="pt-3 alturaTexto">
                  <span class="white--text font-weight-bold tamanoLetra">
                    <a :href="'//'+ archivo.RUTAARCH" target="_blank" download> 
                    {{archivo.NOMBREARCH}} 
                  </a>
                  </span>
                </v-card-text>
                </v-card>
              </v-col>
              <!-- FIN IMAGENES INGRESADAS -->
              <!-- DOCUMENTOS INGRESADOS -->
              <v-col cols="6" xs="12" sm="12" md="6" lg="3"
              class="ma-3 " 
              style="max-width: 120px" 
              v-else-if="!archivo.NOMBREARCH.toLowerCase().match(/(\.jpeg|\.jpg|\.png|\.mp4|\.webm|\.ogg)$/i)"
              >
              <v-card >
                <v-card-title>
                  <v-img :src="require('../../assets/' + mostrarPrevistaImagen(archivo))" class="overflow-visible">
                    <ModalEliminarArchivos 
                    :archivo='archivo'
                    @getInformacionProyecto="getInformacionProyecto"
                    @snackbar="snackbar" 
                    style="float:right; margin-top:-22%; margin-right:-20%;"/>
                  </v-img>
                  
                </v-card-title>

                <v-card-text :class="claseCSSArchivo(archivo)" class="pt-3 alturaTexto">
                  <span class="white--text font-weight-bold tamanoLetra">                      
                      <a :href="'//' + archivo.RUTAARCH">
                      {{archivo.NOMBREARCH}}
                      </a>
                    
                  </span>
                </v-card-text>

              </v-card>
            </v-col>
              <!-- DOCUMENTOS INGRESADOS -->
            </div>
          </v-row>
          <!-- VIDEOS INGRESADOS -->
          <v-row v-if="archivos.length > 0">
            <div v-for="archivo in archivos" :key="archivo.ARCHIVO_ID">
              <v-col v-if="archivo.NOMBREARCH.toLowerCase().match(/(\.ogg|\.mp4|\.webm)$/i)"
              cols="12" sm="12" md="12" >
              <div class="container1">
                <video :src="'//' + archivo.RUTAARCH" width="320" height="240" controls class="allBorde content">
              </video>
                <ModalEliminarArchivos 
                  class="overlay"
                  :archivo='archivo'
                  @getInformacionProyecto="getInformacionProyecto" 
                  />
              </div>
              </v-col>
            </div>
          </v-row>
          <!-- FIN VIDEOS INGRESADOS -->
        </div>
        
        <!-- FIN SECCION ARCHIVOS -->

      </v-card>
    </v-container>
  </div>
  <v-container v-else-if="!mostrarInformacion">
    <div  class="d-flex justify-center">
      <v-card elevation="5">
        <v-card-title>
          <span class="ma-3">Permisos insuficientes.</span>
        </v-card-title>
        <v-card-text>
          <span class="mx-1 font-weight-bold text--primary">No tienes acceso a esta pagina.</span>
        </v-card-text>
        <v-card-actions class="mx-2 my-1">
          <v-btn text light class="primary" @click="regresar">
            <v-icon> mdi-arrow-left</v-icon>
            <span>Salir</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-container>

</template>

<script>
import axios from "axios";
// import ModalExcel from './Modals/ModalExcel.vue';
import ModalAgregarProducto from './Modals/ModalAgregarProducto';
import ModalAgregarArchivos from './Modals/ModalAgregarArchivos';
import ModalEliminarProducto from './Modals/ModalEliminarProducto.vue';
import ModalEliminarArticulo from './Modals/ModalEliminarArticulo.vue';
import ModalEliminarArchivos from './Modals/ModalEliminarArchivos';
// import Articulos from './Articulos.vue';
import { mapGetters } from "vuex";

export default {
  components:{ /*ModalExcel ,*/ ModalEliminarArchivos , 
                ModalAgregarArchivos,  ModalAgregarProducto,
                ModalEliminarProducto , ModalEliminarArticulo},
  data() {
    return {

      //DATOS PARA MODIFICAR Y ENVIAR
      clienteSeleccionado:  "",
      fechaSeleccionada:    null,
      excel :               null,
      factura :             '',
      tipoProyecto:         null,
      costo:                null,
      venta:                null,
      tipo:                 null,
      
      //DATOS PARA VALIDACIONES / MOSTRAR INFORMACION
      proyectoID:'',
      mostrarSnackbar:  false,
      mensajeSnack:     '',
      colorSnack:       '',

      cargandoModificar:false,
      cargandoCliente:  false,
      infoProyecto:     null,
      editar:           true,
      clientes:         [],
      modalFecha:       false,
      minFecha:         "",
      productos:        [],
      archivos:         [],

      mostrarProductos: true,
      modalArchivos:    false,
      mostrarModalProductos: false,
      mostrarInformacion: false,
      usuarioProyectoId:'',
      tiposProyecto: [
        {'TIPO':'PROYECTO', 'VALOR':'P'},
        {'TIPO':'SERVICIO', 'VALOR':'S'},
        ]

    };
  },

  computed: {
    ...mapGetters(["getURLAPI","getFechaActual",'getUsuario','getUsuarioID','getRolesUsuario']),

    mostrarFolio : function () {
      if (this.infoProyecto && this.infoProyecto.FOLIO) {
        return this.infoProyecto.FOLIO
      }
      else{
        return ''
      }
    },

    iconoFlecha : function() {
      return this.mostrarProductos ? "mdi-arrow-up-drop-circle":"mdi-arrow-down-drop-circle"
    },

    mostrarExcel : function () {
      if (this.excel && this.excel.name){
        return this.excel.name
      }
      return ""
    },

  },

  methods: {
    // ------------------------------------------------------------------------------
    getInformacionProyecto( id ) 
    {
      this.infoProyecto = null;
      this.fechaSeleccionada = "";
      this.archivos = [];
      this.mostrarInformacion = true;
      axios.get(`${this.getURLAPI}/Proyecto/informacionProyecto/${id}`)
      .then( ( { data } ) => 
      {
        console.log(data);
        if (data && data.length > 0) 
        {
          this.infoProyecto = data[0];
          this.usuarioProyectoId = this.infoProyecto.USUARIO_ID
          this.fechaSeleccionada = data[0].PROYECTO_ENTREGA.split(' ')[0];
          this.factura = data[0].FACTURA ?? '';
          this.tipo = data[0].TIPO;
          this.venta = data[0].VENTA ?? '';
          this.costo = data[0].COSTO ?? '';

          for (const arch of data) 
          {
            if (arch.RUTAARCH != null && arch.AESTATUS !== 'B') {
              this.archivos.push(arch)
              console.log(arch);
            }
          }
          console.log(this.infoProyecto);
          this.mostrarInformacion = false;
        }

      })
    },

    // ------------------------------------------------------------------------------
    async getClientes( id ){
      this.mostrarProductos = false;
      this.cargandoCliente = true;
      this.clientes = (await axios.get(`${this.getURLAPI}/show/allClient`)).data
      this.clienteSeleccionado = (await axios.get(`${this.getURLAPI}/Proyecto/projectClient/${id}`)).data;
      console.log(this.clienteSeleccionado);
      this.cargandoCliente = false;
    },

    // ------------------------------------------------------------------------------
    async getProductosProyecto ( id ) {
      try{
        this.productos = (await axios.get(`${this.getURLAPI}/Proyecto/getProductosProyecto/${id}`)).data
        console.log(this.productos);
  
        for (const producto of this.productos) {
          producto.ARTICULOS = (
          await axios.get(`${this.getURLAPI}/Proyecto/getArticulosProducto/${producto.PRODUCTO_ID}`)
          ).data
          
        }
        this.mostrarProductos = true;
      }
      catch( err ){
        console.log(err);
      }
    },

    // ------------------------------------------------------------------------------
    archivoExcel( excel ){
      if (excel) {
        this.excel = excel;
      } else {
        this.excel = null;
      }
    },

    // ------------------------------------------------------------------------------
    mostrarPrevistaImagen( arch ) {
      if (!arch) return;

      if (arch.NOMBREARCH.toLowerCase().match(/(\.docx|\.doc)$/i)) { // WORD
        return 'word.png'
      } else if ( arch.NOMBREARCH.toLowerCase().match(/(\.xls|\.xlsx)$/i) ) { // EXCEL
        console.log(arch);
        return "excel.png"
      } else if ( arch.NOMBREARCH.toLowerCase().match(/(\.pdf)$/i) ) { // PDF
        return 'pdf.png'
      } else if ( arch.NOMBREARCH.toLowerCase().match(/(\.txt)$/i) ) { // PDF
        return 'texto.png'
      } else if ( arch.NOMBREARCH.toLowerCase().match(/(\.rar|\.zip)$/i) ) { // PDF
        return 'rar.png'
      }
      else{
        return 'default.png'
      }
    },

    // ------------------------------------------------------------------------------
    claseCSSArchivo( arch ){
      if (!arch) return;
      
      if (arch.NOMBREARCH.toLowerCase().match(/(\.docx|\.doc)$/i)) { // WORD
        return 'blue darken-2'
      } else if ( arch.NOMBREARCH.toLowerCase().match(/(\.xls|\.xlsx)$/i) ) { // EXCEL
        return "green darken-2"
      } else if ( arch.NOMBREARCH.toLowerCase().match(/(\.pdf)$/i) ) { // PDF
        return 'red darken-2'
      } else if ( arch.NOMBREARCH.toLowerCase().match(/(\.rar|\.zip)$/i) ) { // PDF
        return 'purple lighten-2'
      }
      else{
        return 'grey darken-2'
      }
    },

    // ------------------------------------------------------------------------------
    snackbar( data ){
      this.mostrarSnackbar = true;
      this.mensajeSnack = data.MSG;
      
      if ( data.STATUS !== "ERROR" ) {
        this.colorSnack = 'success darken-1'
      }
      else{
        this.colorSnack = 'red lighten-1'
      }
    },

    // ------------------------------------------------------------------------------
    eliminarProducto( producto_id ) {
      let datosForm = new FormData();
      datosForm.append("PROYECTO_ID", this.infoProyecto.PID);
      datosForm.append("PRODUCTO_ID", producto_id);

      axios.post(`${this.getURLAPI}/Proyecto/quitarProducto`, datosForm)
      .then( ({data}) =>{
        this.snackbar( data );
        this.getProductosProyecto(this.proyectoID);
      })
      .catch( () => {
        this.mostrarSnackbar = true;
        this.mensajeSnack = "Error en el servidor.";
        this.colorSnack = "red lighten-1";
        this.cargandoModificar = false;
      })
    },

    // ------------------------------------------------------------------------------
    eliminarArticulo( producto_id, articulo_id ) {
      let datosForm = new FormData();
      datosForm.append("PROYECTO_ID", this.infoProyecto.PID);
      datosForm.append("PRODUCTO_ID", producto_id);
      datosForm.append("ARTICULO_ID", articulo_id);

      console.log(this.infoProyecto.PID);
      console.log(producto_id);
      console.log(articulo_id);
      
      axios.post(`${this.getURLAPI}/Proyecto/quitarArticulo`, datosForm)
      .then( ({data}) =>{
        this.snackbar( data );
        this.getProductosProyecto(this.proyectoID);

      } )
      .catch( () =>{
        this.mostrarSnackbar = true;
        this.mensajeSnack = "Error en el servidor.";
        this.colorSnack = "red lighten-1";
        this.cargandoModificar = false;
      })
    },

    // ------------------------------------------------------------------------------
    modificarProyecto(){
      try 
      { 
        this.cargandoModificar = true;
        let datosForm = new FormData();

        datosForm.append('PROYECTO_ID',   this.infoProyecto.PID);
        datosForm.append('CLIENTE_ID',    this.clienteSeleccionado[0].CLIENTE_ID);
        datosForm.append('FECHA_ENTREGA', this.fechaSeleccionada);
        datosForm.append('USUARIO_MODIFICACION', this.getUsuario);
        datosForm.append('COSTO', this.costo);
        datosForm.append('VENTA', this.venta);
        datosForm.append('TIPO',  this.tipo);
        
        if(this.factura != '') {
          datosForm.append('FACTURA',       this.factura);
        }

        axios.post(`${this.getURLAPI}/Proyecto/modificarProyecto`,datosForm)
        .then( ({data}) => 
        {
          // console.log(data);
          this.snackbar(data);
          this.cargandoModificar = false;
          this.getInformacionProyecto(this.proyectoID);
        })
        .catch( () =>
        {
          this.mostrarSnackbar = true;
          this.mensajeSnack = "Error en el servidor.";
          this.colorSnack = "red lighten-1";
          this.cargandoModificar = false;
        } )

      } catch ( err ) 
      {
        this.mostrarSnackbar = true;
        this.mensajeSnack = "Verifica los datos ingresados.";
        this.colorSnack = "red lighten-1";
        this.cargandoModificar = false;
      }

    },

    regresar(){
      this.$router.push({name:"Proyecto"})
    }
  },

  // ------------------------------------------------------------------------------
  created() {
    
    document.title = "Modificar Proyecto | Bombas y Suministros del Norte"
    this.proyectoID = this.$route.params['id'];
    
    this.getInformacionProyecto(this.proyectoID);
    this.getClientes(this.proyectoID);
    this.minFecha = this.getFechaActual.split(" ");
    
    this.getProductosProyecto(this.proyectoID);
  },
};
</script>

<style>
  .fade-enter-active {
    transition: opacity .5s
  }

  .fade-enter, .fade-leave-active {
    opacity: 0;  
  }

  .borde{
    border-style: solid;
    border-color: rgba(128, 128, 128, 0.349);
    border-width: 0px 0px 1px 0px;
  }
  .allBorde{
    border-style: solid;
    border-color: rgba(128, 128, 128, 0.349);
    border-width: 1px 1px 1px 1px;
  }

  .v-expansion-panel-content__wrap{
    padding: 5px 17px 10px!important;
  }

  .noselect {
    -webkit-touch-callout: none;
      -webkit-user-select: none;
       -khtml-user-select: none;
         -moz-user-select: none;
          -ms-user-select: none;
              user-select: none;
  }

  .container1 {
    display: grid;
  }

  .content, .overlay {
    grid-area: 1 / 1;
  }
  span > a{
    color: white!important;
    text-decoration: none;
  }

  span > a:hover{
    color: rgb(0, 112, 177)!important;
    text-decoration: underline;
  }
</style>
